import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'

import { ADMIN_NAV_ITEMS } from '@/app/layout/nav-items'
import { OptionSelect } from '@/components/filters/OptionSelect'
import { messages } from '@/lib/messages'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/stores/auth-store'

/**
 * Yönetim bölümleri: masaüstünde solda dikey menü, mobilde (md altı) üstte seçici
 * (docs/ADMIN-PANEL-PLAN.md Faz 1). Yalnızca yetkili bölümler görünür.
 */
export function AdminLayout() {
  // `hasPermission` fonksiyonunu seçmek yetmez: referansı sabit, kimlik geç gelince yeniden çizilmez.
  const identity = useAuthStore((state) => state.identity)
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const items = ADMIN_NAV_ITEMS.filter(
    (item) =>
      !!identity &&
      (identity.is_superadmin ||
        (typeof item.permission === 'string' ? [item.permission] : (item.permission ?? [])).some(
          (key) => identity.permissions.includes(key),
        )),
  )
  const current = items.find((item) => pathname.startsWith(item.to))

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-start md:gap-6">
      {items.length > 0 && (
        <OptionSelect
          className="w-full md:hidden"
          aria-label={messages.nav.adminSections}
          value={current?.to ?? ''}
          options={items.map((item) => ({ value: item.to, label: item.label }))}
          onValueChange={(to) => void navigate(to)}
        />
      )}
      <nav
        aria-label={messages.nav.adminSections}
        className="hidden w-48 shrink-0 flex-col gap-0.5 md:sticky md:top-4 md:flex"
      >
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'text-text-secondary hover:bg-sidebar-accent hover:text-foreground focus-visible:ring-ring flex h-8 items-center gap-2 rounded-md px-2 text-[13px] outline-hidden transition-colors focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0',
                isActive && 'bg-sidebar-accent text-foreground font-medium',
              )
            }
          >
            <item.icon aria-hidden="true" />
            <span className="truncate">{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  )
}
